<template>
  <TenderDetail :tender="tender" :getTender="getTender" type="myBidsTender" />
</template>

<script>
import TenderDetail from '@/components/app/tenders/tenderDetail/TenderDetail'
import TenderApi from '@/services/apiCalls/tenders/tenders'
import ErrorHandler from '@/utils/ErrorHandler.js'

export default {
  name: 'MyBidsTenderDetail',

  components: {
    TenderDetail,
  },

  data() {
    return {
      tender: null,
    }
  },

  created() {
    this.getTender()
  },

  methods: {
    async getTender() {
      this.$store.commit('spinner', true)

      try {
        const response = await TenderApi.getMyBid(this.$route.params.id)
        this.$store.commit('spinner', false)

        const {
          id,
          mpID,
          status,
          job,
          jobStatus,
          tenderers,
          value,
          errorMessage,
          date,
          documents,
        } = response.data.getMyBid

        this.tender = {
          ...response.data.getMyBid.tender,
          bids: [
            {
              id,
              mpID,
              status,
              job,
              jobStatus,
              tenderers,
              value,
              errorMessage,
              date,
              documents,
            },
          ],
        }

        return response
      } catch (err) {
        this.$store.commit('spinner', false)
        ErrorHandler(err, this)
        return err
      }
    },
  },
}
</script>
